import cn from 'classnames';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import {twx} from '../../../../utils/tailwindUtils';
import {AppButton} from '../../../Button';
import {ContentWrapper} from '../../../Layout';
import styles from './InstructionStepsList.module.scss';

const InstructionStepsList = (props) => {
    const {
        subTitle,
        instructionKey,
        instructionText,
        instructionButton,
        skipButton,
        className,
        subTitleClassName,
        children,
    } = props;
    const localizedStrings = getLocalizedStrings();

    return (
        <div
            className={twx(
                {
                    'mt-8 bg-secondary pb-10 pt-8 sm:mt-12 lg:mt-10': instructionKey,
                },
                'w-full text-primary',
                className
            )}
        >
            <ContentWrapper>
                {instructionKey && (
                    <>
                        <h2 className={twMerge('mb-4 text-24 md:mb-8', subTitleClassName)}>{subTitle}</h2>
                        <ul
                            className={cn('text-start', styles.InstructionStepsList)}
                            dangerouslySetInnerHTML={{
                                __html: instructionText || localizedStrings[instructionKey],
                            }}
                        />
                    </>
                )}
                {children}
                {instructionButton && <AppButton {...instructionButton} />}
                {skipButton && <AppButton {...skipButton} />}
            </ContentWrapper>
        </div>
    );
};

export default InstructionStepsList;
